import StickyNote2RoundedIcon from '@mui/icons-material/SupervisorAccount';
import { Avatar, Box, Typography } from '@mui/material';
import TimeAgo from 'javascript-time-ago';
import { useTranslation } from 'react-i18next';
import { NotificationFieldsFragment } from '../../../../../../../../generated/core-api/graphql-react-query';

export default function CardCommentNotificationBox(props: { notification: NotificationFieldsFragment }) {
  const { notification } = props;
  const { t, i18n } = useTranslation('widgets');
  const timeAgo = new TimeAgo(i18n.language);

  return (
    <>
      <Avatar className="user">
        <StickyNote2RoundedIcon />
      </Avatar>
      <Box className="message userRoleChanged">
        <Typography variant="subtitle1">
          <strong>{notification.event.author?.displayName}</strong>
          {t('notifications.card.comment')}
          <strong>{notification.event.card?.title}</strong>
        </Typography>
        <Typography variant="subtitle2">
          {timeAgo.format(new Date(notification.date))}
        </Typography>
      </Box>
    </>
  );
}
